import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { hasAnalyticsConsent, CONSENT_CHANGED_EVENT } from "@/lib/consent";

// Mounts Vercel's <Analytics /> ONLY after the user accepts analytics
// consent. Without this component rendered, every track() call is a silent
// no-op (the tracking script is never loaded) which is why events weren't
// being collected. Gating the mount on consent keeps the privacy model:
// nothing loads until the user opts in, and it starts immediately when they
// click Accept (via the consent-changed event, no reload needed).
export default function ConsentedAnalytics() {
  const [enabled, setEnabled] = useState<boolean>(() =>
    hasAnalyticsConsent()
  );

  useEffect(() => {
    const update = () => setEnabled(hasAnalyticsConsent());
    // React to the in-app Accept/Decline choice, and to consent changes made
    // in another tab (storage event).
    window.addEventListener(CONSENT_CHANGED_EVENT, update);
    window.addEventListener("storage", update);
    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, update);
      window.removeEventListener("storage", update);
    };
  }, []);

  if (!enabled) return null;
  return <Analytics />;
}
